import { render, staticRenderFns } from "./FacilitiesVietnamPage.vue?vue&type=template&id=c1d6f9ee&scoped=true&"
import script from "./FacilitiesVietnamPage.vue?vue&type=script&lang=js&"
export * from "./FacilitiesVietnamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d6f9ee",
  null
  
)

export default component.exports